import { createSlice } from '@reduxjs/toolkit';
import { deserialize } from 'deserialize-json-api';
// utils
import axios from '../../../utils/axios';
import { dispatch } from '../../store';

const initialState = {
  isLoading: false,
  suppliersData: [],
  pendingOrdersSuppliers: [],
  period: {},
  totalCount: 0,
};

const slice = createSlice({
  name: 'Suppliers of a specific retailer',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // Success Deliveries
    getSuppliersDataSuccess(state, action) {
      state.isLoading = false;
      state.suppliersData = action.payload.data;
    },
    getTotalCount(state, action) {
      state.totalCount = action.payload.total_count;
    },
    getPendingOrdersSuppliers(state) {
      state.pendingOrdersSuppliers = state.suppliersData.filter((supplier) => supplier.ordersDeliveredLate.length > 0);
    },
  },
});

// reducers
export default slice.reducer;

export function getSuppliersData(startDate, endDate, page, rowsPerPage, shipper_id, outlet_id) {
  return async () => {
    try {
      dispatch(slice.actions.startLoading());
      const params = {
        page: page,
        per_page: rowsPerPage,
        ...(shipper_id && { shipper_id }),
        ...(outlet_id && { outlet_id }),
        start_date: startDate,
        end_date: endDate,
      };
      let pathName = `/retailer_app/api/v1/retailer/shippers_orders`;
      const response = await axios.get(pathName, { params: params });
      const data = deserialize(response.data, { transformKeys: 'camelCase' });

      dispatch(slice.actions.getTotalCount(response.data));

      dispatch(slice.actions.getSuppliersDataSuccess(data));
      dispatch(slice.actions.stopLoading());
    } catch (error) {
      console.error('Error fetching retailer suppliers:', error);
      throw error;
    }
  };
}

export function getPendingOrdersSuppliers() {
  dispatch(slice.actions.getPendingOrdersSuppliers());
}
